import React from 'react';
import FileUpload from '../../../components/FileUpload';

const FormFileUpload = ({ formData, onFileChange, onFileRemove }) => {
  return (
    <div className="bg-[var(--bg-primary)] p-6 rounded-xl shadow-[var(--shadow-sm)] border border-[var(--border-color)]">
      <FileUpload
        files={formData.files || []}
        onFileChange={onFileChange}
        onFileRemove={onFileRemove}
        maxFiles={3}
        label="Lampiran Administrasi"
      />
    </div>
  );
};

export default FormFileUpload;